import { render, staticRenderFns } from "./WameedTextArea.vue?vue&type=template&id=63e4704d&"
import script from "./WameedTextArea.vue?vue&type=script&lang=js&"
export * from "./WameedTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports